export const HEADER_LOGO = 'header.logo';
export const MOBILE_MENU_ARIA_LABEL = 'mobile_menu.aria_label';
export const MOBILE_SEARCH_ARIA_LABEL = 'mobile_search.aria_label';
export const MOBILE_CLOSE_SEARCH_ARIA_LABEL = 'mobile_close_search.aria_label';
